import { Show } from 'solid-js'

import { useI18n } from '../../i18n'
import {
   activeTab,
   isTabMenuCollapsed,
   toggleTabMenuCollapsed,
} from '../../state/appUiStore'

/**
 * Renders the app header with the active tab label.
 *
 * @returns The header element.
 */
const Header = () => {
   const t = useI18n()
   /**
    * Returns the localized label for the active tab.
    *
    * @returns The tab label.
    */
   const tabLabel = () => {
      if (activeTab() === 'history') {
         return t('History')
      }
      if (activeTab() === 'measurements') {
         return t('Measurements')
      }
      if (activeTab() === 'account') {
         return t('Account')
      }
      if (activeTab() === 'habits') {
         return t('Habits')
      }
      return t('Current Fast')
   }

   return (
      <header class="flex items-start justify-between gap-3 mb-3 text-left lg:mb-0 lg:col-span-2">
         <div class="flex flex-col gap-1">
            <h1 class="text-2xl font-bold text-ink sm:text-3xl lg:text-4xl">
               {t('Faster · Leaner · Stronger')}
            </h1>
            <Show when={activeTab() !== 'habits'}>
               <span
                  id="active-tab-label"
                  class="block mt-3 text-2xl font-semibold text-left text-accent-active sm:hidden"
               >
                  {tabLabel()}
               </span>
            </Show>
         </div>
         <button
            id="tab-menu-toggle"
            type="button"
            onClick={toggleTabMenuCollapsed}
            aria-expanded={isTabMenuCollapsed() ? 'false' : 'true'}
            aria-controls="tab-button-group"
            aria-label={t('Toggle navigation')}
            class="sm:hidden inline-flex items-center justify-center rounded-lg border border-edge-soft bg-surface-raised p-2 text-ink-soft transition hover:bg-surface-control focus:outline-none focus:ring-2 focus:ring-accent-strong"
         >
            <svg
               xmlns="http://www.w3.org/2000/svg"
               width="20"
               height="20"
               fill="currentColor"
               viewBox="0 0 24 24"
            >
               <path
                  d="M3 6h18M3 12h18M3 18h18"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
               />
            </svg>
         </button>
      </header>
   )
}

export default Header
